import React from "react";
import PropTypes from "prop-types";
import LabelAndDots from "./LabelAndDots";
import StateDropdown from "../../../components/Dropdown/StateDropdown";
import { US_STATES } from "../../../Constants";

const StateField = ({
  field,
  formData,
  handleChange,
  readOnly,
  validationErrors,
}) => {
  const isFieldReadOnly = readOnly || field.key === "managementId";
  const errorClass = validationErrors[field.key] ? "border border-red-500" : "";
  return (
    <div className="flex flex-col w-full">
      <div className="flex items-center w-full">
        <label
          className="flex items-center text-sm"
          style={{
            lineHeight: "1.2",
            whiteSpace: "nowrap",
            overflow: "hidden",
            width: "12.5em",
          }}
        >
          <LabelAndDots
            label={field.label}
            tooltip={field.tooltip}
            required={field.required && !!validationErrors[field.key]}
          />
        </label>
        <div
          className={`flex-grow size-7 ${errorClass} ${
            isFieldReadOnly ? "" : "border border-black"
          }`}
        >
          <StateDropdown
            value={
              US_STATES.find((s) => s.abbreviation === formData[field.key]) ||
              null
            }
            onChange={(newValue) =>
              handleChange({
                target: {
                  name: field.key,
                  value: newValue ? newValue.abbreviation : "",
                },
              })
            }
            disabled={readOnly}
            placeholder="Select a state"
            className="flex-grow"
          />
        </div>
      </div>
      {validationErrors[field.key] && (
        <div className="text-red-500 text-sm mt-1 text-end">
          {validationErrors[field.key]}
        </div>
      )}
    </div>
  );
};

StateField.propTypes = {
  field: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  validationErrors: PropTypes.object,
};

export default StateField;
